module.exports = __webpack_public_path__ + "assets/5f4817c846eb821cb46bd63cb79f6e93.png";